import { render, staticRenderFns } from "./campaign-toggle-row.vue?vue&type=template&id=5e15abd8&scoped=true&"
import script from "./campaign-toggle-row.vue?vue&type=script&lang=js&"
export * from "./campaign-toggle-row.vue?vue&type=script&lang=js&"
import style0 from "./campaign-toggle-row.vue?vue&type=style&index=0&id=5e15abd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e15abd8",
  null
  
)

export default component.exports